import React, { useState } from 'react';
import Messenger from './Chat/components/Messenger/Messenger';
import './ChatBotWidget.scss';
import { openBotChat } from '../utils/chatUtils';
import { useDispatch, useSelector } from 'react-redux';
import { FiMessageCircle, FiX } from 'react-icons/fi';
import { BsChatDots, BsRobot } from 'react-icons/bs';
const ChatBotWidget = () => {
    const [open, setOpen] = useState(false);
    const dispatch = useDispatch();
    const chats = useSelector(state => state.chatReducer.chats);

    const handleChatToggle = () => {
        setOpen(!open)
        openBotChat(chats, dispatch); // Open or create the bot chat
    };

  return (
    <div className="chatbot-widget">
      {open && (
        <div className="chat-window shadow">
          <Messenger />
        </div>
      )}
      <button
        className="chatbot-toggle-button"
        onClick={handleChatToggle}
        aria-label={open ? "Close chatbot" : "Open chatbot"}
        title={open ? "Close chatbot" : "Chat with us"}
      >
        {open ? <FiX size={24} /> : <BsRobot size={24} color="#007AFF" />}

      </button>
    </div>
  );
};

export default ChatBotWidget;
